import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import { useLocation } from 'react-router-dom';
const HEADING_FONT = "'RobotoCondensed VariableFont Wght', Roboto Condensed, sans-serif";
interface CommentReply {
  id: string;
  author: string;
  initials: string;
  color: string;
  content: string;
  time: string;
}
interface CommentPin {
  id: string;
  number: number;
  x: number;
  y: number;
  author: string;
  initials: string;
  color: string;
  content: string;
  time: string;
  resolved: boolean;
  page: string;
  replies: CommentReply[];
}
const initialComments: CommentPin[] = [{
  id: 'c1',
  number: 1,
  x: 72,
  y: 280,
  author: 'Marco Rossi',
  initials: 'MR',
  color: '#293B54',
  content: 'La timeline non è aggiornata, manca lo step di rendicontazione. Verificare con il team tecnico.',
  time: '2 ore fa',
  resolved: false,
  page: '/candidature/1',
  replies: [{
    id: 'r1',
    author: 'Laura Bianchi',
    initials: 'LB',
    color: '#00497A',
    content: 'Confermo, ho aperto un ticket al team di sviluppo. Fix previsto per venerdì.',
    time: '1 ora fa'
  }]
}, {
  id: 'c2',
  number: 2,
  x: 55,
  y: 520,
  author: 'Anna Colombo',
  initials: 'AC',
  color: '#2A97DF',
  content: 'Verificare importo contributo: sembra inferiore al minimo previsto dal bando (€45.000). Contattare il soggetto proponente.',
  time: '5 ore fa',
  resolved: false,
  page: '/candidature/1',
  replies: []
}, {
  id: 'c3',
  number: 3,
  x: 18,
  y: 460,
  author: 'Giuseppe Verdi',
  initials: 'GV',
  color: '#0E74B8',
  content: 'Soggetto già segnalato per irregolarità nella rendicontazione edizione 2024. Prestare attenzione alla documentazione.',
  time: 'Ieri, 16:30',
  resolved: true,
  page: '/candidature/1',
  replies: [{
    id: 'r2',
    author: 'Marco Rossi',
    initials: 'MR',
    color: '#293B54',
    content: 'Grazie per la segnalazione. Ho aggiunto una nota nel fascicolo.',
    time: 'Ieri, 17:00'
  }]
}, {
  id: 'c4',
  number: 4,
  x: 40,
  y: 150,
  author: 'Laura Bianchi',
  initials: 'LB',
  color: '#00497A',
  content: 'Ricordare di esportare i dati aggiornati prima della riunione di lunedì.',
  time: '20 Mag 2025',
  resolved: false,
  page: '/dashboard',
  replies: []
}, {
  id: 'c5',
  number: 5,
  x: 60,
  y: 320,
  author: 'Marco Rossi',
  initials: 'MR',
  color: '#293B54',
  content: 'Il Bando 3 ha un numero anomalo di candidature rispetto allo storico. Possibile errore di importazione?',
  time: '18 Mag 2025',
  resolved: false,
  page: '/bandi',
  replies: []
}];
const teamMembers = [{
  name: 'Marco Rossi',
  initials: 'MR',
  color: '#293B54'
}, {
  name: 'Laura Bianchi',
  initials: 'LB',
  color: '#00497A'
}, {
  name: 'Anna Colombo',
  initials: 'AC',
  color: '#2A97DF'
}, {
  name: 'Giuseppe Verdi',
  initials: 'GV',
  color: '#0E74B8'
}];
const pageOptions = [{
  value: '/dashboard',
  label: 'Dashboard'
}, {
  value: '/bandi',
  label: 'Gestione Bandi'
}, {
  value: '/candidature',
  label: 'Candidature'
}, {
  value: '/candidature/1',
  label: 'Candidatura #2025-0142'
}, {
  value: '/valutatori',
  label: 'Gestione Valutatori'
}, {
  value: '/gestione-utenti',
  label: 'Gestione Utenti'
}, {
  value: '/soggetti',
  label: 'Soggetti Proponenti'
}, {
  value: '/ticket/analisi',
  label: 'Analisi Ticket'
}];
interface CommentSystemProps {
  commentMode: boolean;
  panelOpen: boolean;
  onPanelClose: () => void;
  onCommentModeOff?: () => void;
  onPageCommentCount?: (count: number) => void;
  children: React.ReactNode;
}
export function CommentSystem({
  commentMode,
  panelOpen,
  onPanelClose,
  onCommentModeOff,
  onPageCommentCount,
  children
}: CommentSystemProps) {
  const location = useLocation();
  const [comments, setComments] = useState<CommentPin[]>(initialComments);
  const [activeThreadId, setActiveThreadId] = useState<string | null>(null);
  const [newCommentText, setNewCommentText] = useState('');
  const [replyText, setReplyText] = useState('');
  const [panelFilter, setPanelFilter] = useState<'tutti' | 'aperti' | 'risolti'>('tutti');
  const [panelAnimating, setPanelAnimating] = useState(false);
  const [panelVisible, setPanelVisible] = useState(false);
  const [selectedColleagues, setSelectedColleagues] = useState<string[]>([]);
  const [colleagueDropdownOpen, setColleagueDropdownOpen] = useState(false);
  const [selectedPage, setSelectedPage] = useState('');
  const [pageDropdownOpen, setPageDropdownOpen] = useState(false);
  const [pageFilterActive, setPageFilterActive] = useState(true);
  const newCommentInputRef = useRef<HTMLTextAreaElement>(null);
  const replyInputRef = useRef<HTMLTextAreaElement>(null);
  const colleagueDropdownRef = useRef<HTMLDivElement>(null);
  const pageDropdownRef = useRef<HTMLDivElement>(null);
  const currentPage = location.pathname;
  const pageComments = comments.filter(c => c.page === currentPage);
  const displayedComments = pageFilterActive ? comments.filter(c => c.page === currentPage) : comments;
  const pageOpenCount = pageComments.filter(c => !c.resolved).length;
  useEffect(() => {
    onPageCommentCount?.(pageOpenCount);
  }, [pageOpenCount, onPageCommentCount]);
  useEffect(() => {
    if (panelOpen) {
      setPanelVisible(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setPanelAnimating(true));
      });
    } else {
      setPanelAnimating(false);
      const timer = setTimeout(() => setPanelVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [panelOpen]);
  useEffect(() => {
    if (commentMode) {
      setSelectedPage(currentPage);
      if (newCommentInputRef.current) {
        setTimeout(() => newCommentInputRef.current?.focus(), 100);
      }
    }
  }, [commentMode, currentPage]);
  useEffect(() => {
    if (activeThreadId && replyInputRef.current) {
      setTimeout(() => replyInputRef.current?.focus(), 100);
    }
  }, [activeThreadId]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setActiveThreadId(null);
        if (commentMode && onCommentModeOff) {
          onCommentModeOff();
        }
        setNewCommentText('');
        setSelectedColleagues([]);
        setColleagueDropdownOpen(false);
        setPageDropdownOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [commentMode, onCommentModeOff]);
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (colleagueDropdownRef.current && !colleagueDropdownRef.current.contains(e.target as Node)) {
        setColleagueDropdownOpen(false);
      }
      if (pageDropdownRef.current && !pageDropdownRef.current.contains(e.target as Node)) {
        setPageDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);
  const handleAddComment = () => {
    if (!newCommentText.trim()) return;
    const targetPage = selectedPage || currentPage;
    const newComment: CommentPin = {
      id: `c-${Date.now()}`,
      number: comments.length + 1,
      x: 50,
      y: 50,
      author: 'Michael',
      initials: 'MI',
      color: '#2A97DF',
      content: newCommentText.trim(),
      time: 'Adesso',
      resolved: false,
      page: targetPage,
      replies: []
    };
    setComments(prev => [...prev, newComment]);
    setNewCommentText('');
    setSelectedColleagues([]);
    setSelectedPage('');
    setColleagueDropdownOpen(false);
    setPageDropdownOpen(false);
    if (onCommentModeOff) {
      onCommentModeOff();
    }
  };
  const handleAddReply = (commentId: string) => {
    if (!replyText.trim()) return;
    const reply: CommentReply = {
      id: `r-${Date.now()}`,
      author: 'Michael',
      initials: 'MI',
      color: '#2A97DF',
      content: replyText.trim(),
      time: 'Adesso'
    };
    setComments(prev => prev.map(c => c.id === commentId ? {
      ...c,
      replies: [...c.replies, reply]
    } : c));
    setReplyText('');
  };
  const handleResolve = (commentId: string) => {
    setComments(prev => prev.map(c => c.id === commentId ? {
      ...c,
      resolved: !c.resolved
    } : c));
  };
  const handleDeleteComment = (commentId: string) => {
    setComments(prev => prev.filter(c => c.id !== commentId));
    setActiveThreadId(null);
  };
  const filteredPanelComments = displayedComments.filter(c => {
    if (panelFilter === 'aperti') return !c.resolved;
    if (panelFilter === 'risolti') return c.resolved;
    return true;
  });
  const activeThread = comments.find(c => c.id === activeThreadId);
  const toggleColleague = (name: string) => {
    setSelectedColleagues(prev => prev.includes(name) ? prev.filter(n => n !== name) : [...prev, name]);
  };
  const closeNewCommentModal = () => {
    if (onCommentModeOff) onCommentModeOff();
    setNewCommentText('');
    setSelectedColleagues([]);
    setSelectedPage('');
    setColleagueDropdownOpen(false);
    setPageDropdownOpen(false);
  };
  const currentPageLabel = pageOptions.find(p => p.value === (selectedPage || currentPage))?.label || currentPage;
  return <>
      {children}

      {/* New Comment Modal */}
      {commentMode && <div className="fixed inset-0 z-50 flex items-center justify-center" style={{
      backgroundColor: 'rgba(0,0,0,0.15)'
    }} onClick={closeNewCommentModal} data-id="element-83">
          <div className="bg-white w-full max-w-[440px] overflow-hidden" style={{
        borderRadius: '10px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.14)',
        border: '1px solid #EEEEEE'
      }} onClick={e => e.stopPropagation()} data-id="element-84">
            {/* Header */}
            <div className="flex items-center justify-between" style={{
          padding: '14px 20px',
          borderBottom: '1px solid #F5F5F5'
        }} data-id="element-85">
              <h3 style={{
            fontSize: '15px',
            fontWeight: 500,
            color: '#293B54',
            fontFamily: HEADING_FONT,
            margin: 0
          }} data-id="element-86">
                Nuova nota
              </h3>
              <button onClick={closeNewCommentModal} style={{
            background: 'none',
            border: 'none',
            color: '#CCCCCC',
            cursor: 'pointer',
            padding: '2px'
          }} className="hover:text-[#80858E] transition-colors" data-id="element-87">
                <Icon icon="tabler:x" fontSize={18} data-id="element-88" />
              </button>
            </div>

            {/* Form body */}
            <div style={{
          padding: '16px 20px'
        }} data-id="element-89">
              {/* Page selector */}
              <div style={{
            marginBottom: '14px'
          }} ref={pageDropdownRef} data-id="element-90">
                <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: 500,
              color: '#80858E',
              fontFamily: HEADING_FONT,
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.3px'
            }} data-id="element-91">
                  Pagina
                </label>
                <div className="relative" data-id="element-92">
                  <button onClick={() => setPageDropdownOpen(!pageDropdownOpen)} style={{
                width: '100%',
                height: '36px',
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: '13px',
                fontFamily: 'Roboto, sans-serif',
                color: '#293B54',
                backgroundColor: '#FFFFFF',
                border: '1px solid #E4E4E4',
                borderRadius: '4px',
                cursor: 'pointer'
              }} className="hover:bg-[#F5F5F5] transition-colors" data-id="element-93">
                    <span style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }} data-id="element-94">
                      {currentPageLabel}
                    </span>
                    <Icon icon="tabler:chevron-down" fontSize={14} style={{
                  color: '#AAAAAA',
                  flexShrink: 0,
                  marginLeft: '8px'
                }} data-id="element-95" />
                  </button>
                  {pageDropdownOpen && <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                marginTop: '4px',
                backgroundColor: 'white',
                borderRadius: '6px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                border: '1px solid #EEEEEE',
                zIndex: 60,
                maxHeight: '200px',
                overflowY: 'auto'
              }} data-id="element-96">
                      {pageOptions.map(opt => <button key={opt.value} onClick={() => {
                  setSelectedPage(opt.value);
                  setPageDropdownOpen(false);
                }} style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px 12px',
                  fontSize: '13px',
                  fontFamily: 'Roboto, sans-serif',
                  color: (selectedPage || currentPage) === opt.value ? '#2A97DF' : '#444444',
                  fontWeight: (selectedPage || currentPage) === opt.value ? 500 : 400,
                  backgroundColor: (selectedPage || currentPage) === opt.value ? '#F5F5F5' : 'transparent',
                  border: 'none',
                  cursor: 'pointer'
                }} className="hover:bg-[#F5F5F5] transition-colors" data-id="element-97">
                          {opt.label}
                        </button>)}
                    </div>}
                </div>
              </div>

              {/* Colleague tags */}
              <div style={{
            marginBottom: '14px'
          }} ref={colleagueDropdownRef} data-id="element-98">
                <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: 500,
              color: '#80858E',
              fontFamily: HEADING_FONT,
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.3px'
            }} data-id="element-99">
                  Menziona colleghi
                </label>
                <div className="relative" data-id="element-100">
                  <button onClick={() => setColleagueDropdownOpen(!colleagueDropdownOpen)} style={{
                width: '100%',
                minHeight: '36px',
                padding: '6px 12px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '6px',
                fontSize: '13px',
                fontFamily: 'Roboto, sans-serif',
                color: '#AAAAAA',
                backgroundColor: '#FFFFFF',
                border: '1px solid #E4E4E4',
                borderRadius: '4px',
                cursor: 'pointer',
                textAlign: 'left'
              }} className="hover:bg-[#F5F5F5] transition-colors" data-id="element-101">
                    {selectedColleagues.length === 0 ? <span style={{
                  color: '#AAAAAA',
                  fontSize: '13px'
                }} data-id="element-102">
                        Seleziona...
                      </span> : selectedColleagues.map(name => {
                  const member = teamMembers.find(m => m.name === name);
                  return <span key={name} style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '2px 8px',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontFamily: 'Roboto, sans-serif',
                    color: '#293B54',
                    fontWeight: 500,
                    border: '1px solid #E4E4E4'
                  }} data-id="element-103">
                            <span style={{
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      backgroundColor: member?.color || '#AAAAAA',
                      color: 'white',
                      fontSize: '7px',
                      fontWeight: 600,
                      fontFamily: HEADING_FONT,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }} data-id="element-104">
                              {member?.initials}
                            </span>
                            {name.split(' ')[0]}
                            <button onClick={e => {
                      e.stopPropagation();
                      toggleColleague(name);
                    }} style={{
                      background: 'none',
                      border: 'none',
                      color: '#CCCCCC',
                      cursor: 'pointer',
                      padding: 0,
                      display: 'flex',
                      alignItems: 'center'
                    }} data-id="element-105">
                              <Icon icon="tabler:x" fontSize={12} data-id="element-106" />
                            </button>
                          </span>;
                })}
                    <Icon icon="tabler:chevron-down" fontSize={14} style={{
                  color: '#AAAAAA',
                  flexShrink: 0,
                  marginLeft: 'auto'
                }} data-id="element-107" />
                  </button>
                  {colleagueDropdownOpen && <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                marginTop: '4px',
                backgroundColor: 'white',
                borderRadius: '6px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                border: '1px solid #EEEEEE',
                zIndex: 60,
                maxHeight: '180px',
                overflowY: 'auto'
              }} data-id="element-108">
                      {teamMembers.map(member => {
                  const isSelected = selectedColleagues.includes(member.name);
                  return <button key={member.name} onClick={() => toggleColleague(member.name)} style={{
                    width: '100%',
                    textAlign: 'left',
                    padding: '8px 12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '13px',
                    fontFamily: 'Roboto, sans-serif',
                    color: '#444444',
                    backgroundColor: isSelected ? '#F5F5F5' : 'transparent',
                    border: 'none',
                    cursor: 'pointer'
                  }} className="hover:bg-[#F5F5F5] transition-colors" data-id="element-109">
                            <span style={{
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                      backgroundColor: member.color,
                      color: 'white',
                      fontSize: '8px',
                      fontWeight: 600,
                      fontFamily: HEADING_FONT,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }} data-id="element-110">
                              {member.initials}
                            </span>
                            <span style={{
                      flex: 1
                    }} data-id="element-111">
                              {member.name}
                            </span>
                            {isSelected && <Icon icon="tabler:check" fontSize={14} style={{
                      color: '#2A97DF'
                    }} data-id="element-112" />}
                          </button>;
                })}
                    </div>}
                </div>
              </div>

              {/* Note text */}
              <div style={{
            marginBottom: '16px'
          }} data-id="element-113">
                <label style={{
              display: 'block',
              fontSize: '12px',
              fontWeight: 500,
              color: '#80858E',
              fontFamily: HEADING_FONT,
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.3px'
            }} data-id="element-114">
                  Nota
                </label>
                <textarea ref={newCommentInputRef} value={newCommentText} onChange={e => setNewCommentText(e.target.value)} onKeyDown={e => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleAddComment();
              }
            }} placeholder="Scrivi una nota..." rows={3} style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '13px',
              fontFamily: 'Roboto, sans-serif',
              color: '#444444',
              resize: 'none',
              outline: 'none',
              lineHeight: 1.5,
              backgroundColor: '#FFFFFF',
              border: '1px solid #E4E4E4',
              borderRadius: '4px'
            }} data-id="element-115" />
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3" data-id="element-116">
                <button onClick={closeNewCommentModal} style={{
              background: 'none',
              border: 'none',
              color: '#80858E',
              fontSize: '13px',
              fontFamily: 'Roboto, sans-serif',
              cursor: 'pointer',
              padding: '6px 12px',
              borderRadius: '4px'
            }} className="hover:bg-gray-50 transition-colors" data-id="element-117">
                  Annulla
                </button>
                <button onClick={handleAddComment} disabled={!newCommentText.trim()} style={{
              backgroundColor: newCommentText.trim() ? '#293B54' : '#EEEEEE',
              color: newCommentText.trim() ? 'white' : '#CCCCCC',
              border: 'none',
              borderRadius: '4px',
              padding: '8px 16px',
              fontSize: '13px',
              fontFamily: HEADING_FONT,
              textTransform: 'uppercase',
              letterSpacing: '0.3px',
              cursor: newCommentText.trim() ? 'pointer' : 'default'
            }} className={newCommentText.trim() ? 'hover:bg-[#1a2536] transition-colors' : ''} data-id="element-118">
                  Invia
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* Active Thread Modal */}
      {activeThread && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/15 backdrop-blur-[1px] animate-in fade-in duration-200" data-id="element-119">
          <div className="bg-white rounded-[10px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-[#EEEEEE] w-full max-w-[440px] max-h-[85vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-120">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-[#F5F5F5] flex-shrink-0" data-id="element-121">
              <span style={{
            fontSize: '14px',
            color: '#80858E',
            fontFamily: HEADING_FONT,
            fontWeight: 500
          }} data-id="element-122">
                Nota #{activeThread.number}{' '}
                {activeThread.resolved && '· Risolta'}
              </span>
              <button onClick={() => setActiveThreadId(null)} className="text-[#CCCCCC] hover:text-[#80858E] transition-colors" data-id="element-123">
                <Icon icon="tabler:x" fontSize={20} data-id="element-124" />
              </button>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-5" data-id="element-125">
              <div className="mb-6" data-id="element-126">
                <div className="flex items-center gap-3 mb-2" data-id="element-127">
                  <div style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                backgroundColor: activeThread.color,
                color: 'white',
                fontSize: '11px',
                fontWeight: 600,
                fontFamily: HEADING_FONT,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }} data-id="element-128">
                    {activeThread.initials}
                  </div>
                  <div data-id="element-129">
                    <div style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif',
                  lineHeight: 1.2
                }} data-id="element-130">
                      {activeThread.author}
                    </div>
                    <div style={{
                  fontSize: '11px',
                  color: '#AAAAAA',
                  marginTop: '2px'
                }} data-id="element-131">
                      {activeThread.time}
                    </div>
                  </div>
                </div>
                <p style={{
              fontSize: '14px',
              color: '#444444',
              fontFamily: 'Roboto, sans-serif',
              margin: '0 0 0 40px',
              lineHeight: 1.5
            }} data-id="element-132">
                  {activeThread.content}
                </p>
              </div>

              {activeThread.replies.map(reply => <div key={reply.id} className="mt-4 pt-4 border-t border-[#F5F5F5]" data-id="element-133">
                  <div className="flex items-center gap-3 mb-2" data-id="element-134">
                    <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                backgroundColor: reply.color,
                color: 'white',
                fontSize: '9px',
                fontWeight: 600,
                fontFamily: HEADING_FONT,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }} data-id="element-135">
                      {reply.initials}
                    </div>
                    <div data-id="element-136">
                      <div style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#293B54',
                  fontFamily: 'Roboto, sans-serif',
                  lineHeight: 1.2
                }} data-id="element-137">
                        {reply.author}
                      </div>
                      <div style={{
                  fontSize: '11px',
                  color: '#AAAAAA',
                  marginTop: '2px'
                }} data-id="element-138">
                        {reply.time}
                      </div>
                    </div>
                  </div>
                  <p style={{
              fontSize: '13px',
              color: '#767676',
              fontFamily: 'Roboto, sans-serif',
              margin: '0 0 0 36px',
              lineHeight: 1.5
            }} data-id="element-139">
                    {reply.content}
                  </p>
                </div>)}
            </div>

            {/* Reply + actions */}
            <div className="flex-shrink-0 border-t border-[#F5F5F5] p-4 bg-gray-50/50" data-id="element-140">
              <div className="flex gap-2 mb-3" data-id="element-141">
                <input ref={replyInputRef as any} value={replyText} onChange={e => setReplyText(e.target.value)} onKeyDown={e => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleAddReply(activeThread.id);
              }
            }} placeholder="Rispondi..." style={{
              flex: 1,
              height: '36px',
              border: '1px solid #E4E4E4',
              borderRadius: '6px',
              padding: '0 12px',
              fontSize: '13px',
              fontFamily: 'Roboto, sans-serif',
              color: '#444444',
              outline: 'none'
            }} className="focus:border-[#2A97DF] focus:ring-1 focus:ring-[#2A97DF] transition-all bg-white" data-id="element-142" />
                <button onClick={() => handleAddReply(activeThread.id)} disabled={!replyText.trim()} style={{
              width: '36px',
              height: '36px',
              borderRadius: '6px',
              backgroundColor: replyText.trim() ? '#2A97DF' : '#E4E4E4',
              color: replyText.trim() ? 'white' : '#AAAAAA',
              border: 'none',
              cursor: replyText.trim() ? 'pointer' : 'default',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }} className={replyText.trim() ? 'hover:bg-[#2488c8] transition-colors' : ''} data-id="element-143">
                  <Icon icon="tabler:send" fontSize={16} data-id="element-144" />
                </button>
              </div>
              <div className="flex items-center justify-between" data-id="element-145">
                <button onClick={() => handleResolve(activeThread.id)} className="flex items-center gap-1.5 px-2 py-1 rounded hover:bg-gray-100 transition-colors" style={{
              background: 'none',
              border: 'none',
              color: activeThread.resolved ? '#2e7d32' : '#80858E',
              fontSize: '12px',
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 500,
              cursor: 'pointer'
            }} data-id="element-146">
                  <Icon icon={activeThread.resolved ? 'tabler:circle-check-filled' : 'tabler:circle-check'} fontSize={16} data-id="element-147" />
                  {activeThread.resolved ? 'Riapri nota' : 'Segna come risolta'}
                </button>
                <button onClick={() => handleDeleteComment(activeThread.id)} className="flex items-center gap-1.5 px-2 py-1 rounded hover:bg-red-50 transition-colors" style={{
              background: 'none',
              border: 'none',
              color: '#EA5455',
              fontSize: '12px',
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 500,
              cursor: 'pointer'
            }} data-id="element-148">
                  <Icon icon="tabler:trash" fontSize={15} data-id="element-149" />
                  Elimina
                </button>
              </div>
            </div>
          </div>
        </div>}

      {/* Panel */}
      {panelVisible && <>
          <div data-comment-panel="true" className="fixed inset-0 z-[55]" style={{
        backgroundColor: panelAnimating ? 'rgba(0,0,0,0.4)' : 'transparent',
        backdropFilter: panelAnimating ? 'blur(4px)' : 'none',
        WebkitBackdropFilter: panelAnimating ? 'blur(4px)' : 'none',
        transition: 'background-color 300ms ease, backdrop-filter 300ms ease'
      }} onClick={onPanelClose} data-id="element-150" />
          <div data-comment-panel="true" className="fixed top-0 right-0 bottom-0 z-[56] flex flex-col bg-white" style={{
        width: '360px',
        borderLeft: '1px solid #E4E4E4',
        boxShadow: '-2px 0 16px rgba(0,0,0,0.06)',
        transform: panelAnimating ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 300ms cubic-bezier(0.16, 1, 0.3, 1)'
      }} onClick={e => e.stopPropagation()} data-id="element-151">
            {/* Panel header */}
            <div className="flex items-center justify-between flex-shrink-0" style={{
          padding: '16px 20px',
          borderBottom: '1px solid #F5F5F5'
        }} data-id="element-152">
              <h2 style={{
            fontSize: '20px',
            fontWeight: 400,
            color: '#293B54',
            fontFamily: HEADING_FONT,
            margin: 0
          }} data-id="element-153">
                Note
              </h2>
              <button onClick={onPanelClose} style={{
            background: 'none',
            border: 'none',
            color: '#CCCCCC',
            cursor: 'pointer',
            padding: '2px'
          }} className="hover:text-[#80858E] transition-colors" data-id="element-154">
                <Icon icon="tabler:x" fontSize={18} data-id="element-155" />
              </button>
            </div>

            {/* Page filter chip */}
            <div className="flex items-center gap-2 flex-shrink-0 flex-wrap" style={{
          padding: '10px 20px',
          borderBottom: '1px solid #F5F5F5'
        }} data-id="element-156">
              {pageFilterActive ? <span className="inline-flex items-center gap-1.5" style={{
            padding: '4px 10px 4px 12px',
            backgroundColor: '#F5F5F5',
            borderRadius: '16px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            color: '#293B54',
            fontWeight: 400,
            border: '1px solid #E4E4E4'
          }} data-id="element-157">
                  <Icon icon="tabler:file" fontSize={14} style={{
              color: '#80858E'
            }} data-id="element-158" />
                  {pageOptions.find(p => p.value === currentPage)?.label || currentPage}
                  <button onClick={() => setPageFilterActive(false)} style={{
              background: 'none',
              border: 'none',
              color: '#AAAAAA',
              cursor: 'pointer',
              padding: '0 0 0 2px',
              display: 'flex',
              alignItems: 'center'
            }} className="hover:text-[#293B54] transition-colors" data-id="element-159">
                    <Icon icon="tabler:x" fontSize={14} data-id="element-160" />
                  </button>
                </span> : <button onClick={() => setPageFilterActive(true)} className="inline-flex items-center gap-1.5 hover:bg-[#F5F5F5] transition-colors" style={{
            padding: '4px 12px',
            backgroundColor: 'transparent',
            borderRadius: '16px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            color: '#80858E',
            border: '1px dashed #E4E4E4',
            cursor: 'pointer'
          }} data-id="element-161">
                  <Icon icon="tabler:filter" fontSize={14} data-id="element-162" />
                  Filtra per pagina corrente
                </button>}
            </div>

            {/* Filter tabs */}
            <div className="flex items-center gap-1 flex-shrink-0" style={{
          padding: '8px 20px',
          borderBottom: '1px solid #F5F5F5'
        }} data-id="element-163">
              {(['tutti', 'aperti', 'risolti'] as const).map(filter => {
            const count = filter === 'tutti' ? displayedComments.length : filter === 'aperti' ? displayedComments.filter(c => !c.resolved).length : displayedComments.filter(c => c.resolved).length;
            const isActive = panelFilter === filter;
            return <button key={filter} onClick={() => setPanelFilter(filter)} style={{
              padding: '4px 12px',
              fontSize: '14px',
              fontFamily: HEADING_FONT,
              fontWeight: 400,
              color: isActive ? '#293B54' : '#AAAAAA',
              backgroundColor: isActive ? '#F5F5F5' : 'transparent',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              textTransform: 'capitalize'
            }} className="hover:bg-gray-50 transition-colors" data-id="element-164">
                    {filter} ({count})
                  </button>;
          })}
            </div>

            {/* Comments list */}
            <div className="flex-1 overflow-y-auto" style={{
          padding: '16px 20px'
        }} data-id="element-165">
              {filteredPanelComments.length === 0 ? <div className="flex flex-col items-center justify-center py-16" data-id="element-166">
                  <Icon icon="tabler:messages-off" fontSize={36} style={{
              color: '#EEEEEE',
              marginBottom: '12px'
            }} data-id="element-167" />
                  <p style={{
              fontSize: '14px',
              color: '#80858E',
              fontFamily: 'Roboto, sans-serif',
              textAlign: 'center'
            }} data-id="element-168">
                    Nessuna nota presente in questa pagina.
                  </p>
                </div> : <div className="space-y-3" data-id="element-169">
                  {filteredPanelComments.map(comment => {
              return <button key={comment.id} onClick={() => {
                setActiveThreadId(comment.id);
                onPanelClose();
              }} className="w-full text-left transition-all hover:shadow-md" style={{
                padding: '16px',
                backgroundColor: 'white',
                border: '1px solid #E4E4E4',
                borderRadius: '8px',
                cursor: 'pointer',
                borderLeft: comment.resolved ? '3px solid #E4E4E4' : `3px solid ${comment.color}`
              }} data-id="element-170">
                        <div className="flex items-center gap-2 mb-2" data-id="element-171">
                          <div style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: comment.resolved ? '#CCCCCC' : comment.color,
                    color: 'white',
                    fontSize: '9px',
                    fontWeight: 600,
                    fontFamily: HEADING_FONT,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }} data-id="element-172">
                            {comment.initials}
                          </div>
                          <span style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: comment.resolved ? '#AAAAAA' : '#293B54',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-173">
                            {comment.author}
                          </span>
                          <span style={{
                    fontSize: '12px',
                    color: '#CCCCCC',
                    marginLeft: 'auto',
                    fontFamily: HEADING_FONT
                  }} data-id="element-174">
                            #{comment.number}
                          </span>
                        </div>
                        <p style={{
                  fontSize: '14px',
                  color: comment.resolved ? '#CCCCCC' : '#444444',
                  fontFamily: 'Roboto, sans-serif',
                  margin: 0,
                  lineHeight: 1.5,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }} data-id="element-175">
                          {comment.content}
                        </p>
                        <div className="flex items-center gap-2 mt-3 pt-3" style={{
                  borderTop: '1px solid #F5F5F5'
                }} data-id="element-176">
                          <span style={{
                    fontSize: '12px',
                    color: '#AAAAAA',
                    fontFamily: 'Roboto, sans-serif'
                  }} data-id="element-177">
                            {comment.time}
                          </span>
                          {comment.replies.length > 0 && <span className="flex items-center gap-1 ml-auto" style={{
                    fontSize: '12px',
                    color: '#80858E',
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: 500
                  }} data-id="element-178">
                              <Icon icon="tabler:message" fontSize={14} data-id="element-179" />
                              {comment.replies.length}
                            </span>}
                        </div>
                      </button>;
            })}
                </div>}
            </div>
          </div>
        </>}
    </>;
}